import React from 'react'

const videos = [
  {
    id: '356wp18VQ9s',
    title: 'CSIR — Official Presentation',
    meta: 'Kashi Vishwanath Steels Ltd.',
  },
  // Nayi video add karni ho to yahan object add karo:
  // { id: 'YOUTUBE_VIDEO_ID', title: 'Video Title', meta: 'Description' },
]

export default function KashiVishwanathSteels() {
  return (
    <>
      <style>{`

        .kvs-wrapper {
          min-height: 100vh;
          background: linear-gradient(160deg, #faf7f2 0%, #f0e8d5 50%, #faf7f2 100%);
        //   font-family: 'Lato', sans-serif;
          color: #2a1f0a;
          padding: 40px 20px 60px;
          box-sizing: border-box;
        }
        .kvs-header { text-align: center; margin-bottom: 40px; }
        .kvs-header .logo-line {
          display: flex; align-items: center; justify-content: center;
          gap: 16px; margin-bottom: 10px;
        }
        .kvs-header .divider {
          height: 1px; width: 60px;
          background: linear-gradient(90deg, transparent, #b07820, transparent);
        }
        .kvs-header h1 {
          font-family: 'Cinzel', serif;
          font-size: clamp(18px, 3.5vw, 30px);
          font-weight: 700; color: #8a5e10; margin: 0;
          letter-spacing: 2px;
          text-shadow: 0 2px 8px rgba(140,94,16,0.15);
        }
        .kvs-header .subtitle {
        //   font-family: 'Cinzel', serif;
          font-size: clamp(11px, 1.8vw, 14px);
          color: #b07820; letter-spacing: 4px;
          text-transform: uppercase; margin-top: 6px;
        }
        .section-label {
          display: flex; align-items: center; gap: 12px;
          margin-bottom: 24px; justify-content: center;
        }
        .section-label span {
          font-family: 'Cinzel', serif; font-size: 11px;
          letter-spacing: 3px; color: #b07820; text-transform: uppercase;
        }
        .section-label::before { content: ''; flex: 1; max-width: 80px; height: 1px;
          background: linear-gradient(90deg, transparent, #b07820); }
        .section-label::after  { content: ''; flex: 1; max-width: 80px; height: 1px;
          background: linear-gradient(90deg, #b07820, transparent); }
        .video-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 24px; max-width: 1100px; margin: 0 auto;
        }
        .video-card {
          background: #ffffff;
          border: 1px solid rgba(176,120,32,0.25);
          border-radius: 6px; overflow: hidden;
          box-shadow: 0 2px 12px rgba(140,94,16,0.08);
          transition: border-color 0.3s, box-shadow 0.3s, transform 0.3s;
        }
        .video-card:hover {
          border-color: rgba(176,120,32,0.6);
          box-shadow: 0 8px 32px rgba(140,94,16,0.18);
          transform: translateY(-3px);
        }
        .video-embed { position: relative; width: 100%; padding-top: 56.25%; background: #e8dcc8; }
        .video-embed iframe { position: absolute; top:0; left:0; width:100%; height:100%; border:none; }
        .video-info { padding: 14px 16px; border-top: 1px solid rgba(176,120,32,0.15); background: #fffdf9; }
        .video-info .video-title {
        //   font-family: 'Cinzel', serif; font-size: 13px;
          color: #5a3e10; margin: 0 0 4px; font-weight: 600;
        }
        .video-info .video-meta { font-size: 11px; color: #a08040; letter-spacing: 1px; }
      `}</style>

      <div className="kvs-wrapper">
        <header className="kvs-header">
          <div className="logo-line">
            <div className="divider" />
            <h1>Kashi Vishwanath Steels Ltd.</h1>
            <div className="divider" />
          </div>
          <div className="subtitle">CSIR Video Gallery</div>
        </header>

        <div className="section-label">
          <span>Featured Videos</span>
        </div>

        <div className="video-grid">
          {videos.map((v) => (
            <div className="video-card" key={v.id}>
              <div className="video-embed">
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}`}
                  title={v.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="video-info">
                <div className="video-title">{v.title}</div>
                <div className="video-meta">{v.meta}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}